import { takeLatest, put, call, fork } from "redux-saga/effects";
import CompanyLosService from "../services/company-los-services";
import { message } from "antd";
import { List } from "immutable";
import {
    AssociateRecord
} from "./../records/index";
import { COMPANY_LOS_ACTIONS } from "../constants";
import {
    fetchedCompanyLosProfileList,
    failedFetchCompanyLosProfileList,
    createdCompanyLosProfile,
    failedCreateCompanyLosProfile,
    fetchCompanyLosProfileList,
    fetchedCompanyLosAttachments,
    failedFetchCompanyLosAttachments,
    fetchedCompanyLosDetail,
    fetchDbRiskControlDetail,
    failedFetchCompanyLosDetail,
    fetchedDbRiskControlDetail,
    failedFetchDbRiskControlDetail,
    updatedDbRiskControlDetail,
    failedUpdateDbRiskControlDetail,
    fetchedCompanyLosProfile,
    failedFetchCompanyLosProfile,
    failedUpdateCompanyLosProfile,
    updatedCompanyLosProfile,
    failedUpdateCompanyLosDetail,
    updatedCompanyLosDetail,
    updatedCompanyLosAttachments,
    failedUpdateCompanyLosAttachments,
    // updateCompanyLosSpocUser,
    updatedCompanyLosSpocUser,
    failedUpdateCompanyLosSpocUser,
    // updateCompanyDisbursalAccount,
    updatedCompanyDisbursalAccount,
    failedUpdateCompanyDisbursalAccount,
    updatedCompanyLosErps,
    failedUpdateCompanyLosErps,
    updatedCompanyLosBankingFacilities,
    failedUpdateCompanyLosBankingFacilities,
    updatedCompanyLosAnnualTurnovers,
    failedUpdateCompanyLosAnnualTurnovers,
    updatedCompanyLosBrands,
    failedUpdateCompanyLosBrands,
    fetchedCompanyLosErps,
    failedFetchCompanyLosErps,
    fetchedCompanyLosBankingFacilities,
    failedFetchCompanyLosBankingFacilities,
    fetchedCompanyLosAnnualTurnovers,
    failedFetchCompanyLosAnnualTurnovers,
    fetchedCompanyLosBrands,
    failedFetchCompanyLosBrands,
    updatedCompanyLosSchemes,
    failedUpdateCompanyLosSchemes,
    fetchedCompanyLosSchemes,
    failedFetchCompanyLosSchemes,
    fetchedFee,
    failedFetchFee,
    fetchedFeeMaster,
    failedFetchFeeMaster,
    fetchedAddFee,
    failedFetchAddFee,
    fetchFee,
    deletedBrands,
    failedeleteBrands,
    fetchCompanyLosErps,
    fetchCompanyLosBankingFacilities,
    fetchCompanyLosAnnualTurnovers,
    fetchCompanyLosBrands,
    fetchedTenorList,
    failedFetchTenorList,
    fetchedMarginList,
    failedFetchMarginList,
    fetchedCashbackList,
    failedFetchCashbackList,
    failedFetchInterestList,
    fetchedInterestList,
    fetchedCompanySellerSchemes,
    failedFetchCompanySellerSchemes,
    createdSellerSchemeMapping,
    failedCreateSellerSchemeMapping,
    createdSellerScheme,
    failedCreateSellerScheme,
    fetchedCompanySellerSchemesMappings,
    failedFetchCompanySellerSchemesMappings,
    updatedSellerScheme,
    failedUpdateSellerScheme,
    updatedSellerSchemeMapping,
    failedUpdateSellerSchemeMapping,
    failedFetchWithholdPercMaster,
    fetchedWithholdPercMaster,
    fetchedCompanySyncRequest,
    failedFetchCompanySyncRequest,
    fetchedCompanySyncRequestCount,
    failedFetchCompanySyncRequestCount,
    fetchedCompanySyncRequestProcessReject,
    failedFetchCompanySyncRequestProcessReject,
    fetchCompanySyncRequest,
    fetchCompanySyncRequestCount,
    fetchedDataSyncRequest,
    failedFetchDataSyncRequest,
    createdCompanyAgreement,
    failedCreateCompanyAgreement,
    fetchedCompanyAgreement,
    failedFetchCompanyAgreement,
    updatedCompanyAgreement,
    failedUpdateCompanyAgreement,
    fetchedCompanyAgreementDetail,
    failedFetchCompanyAgreementDetail,
    updatedCompanyAddress,
    failedUpdateCompanyAddress,
    // updateCompanyLosDetail,
    uploadedCompanyLosAttachment,
    failedUploadCompanyLosAttachment,
    validatedDocument,
    invalidatedDocument,
    failedInvalidateDocument,
    failedValidateDocument,
    fetchSellerLedgerMaster,
    fetchedSellerLedgerMaster,
    failedFetchSellerLedgerMaster,
    updatedSellerLedgerMaster,
    failedUpdateSellerLedgerMaster,
    // fetchCompanyLosAttachments
    fetchRetailerMapping,
    fetchedRetailerMapping,
    failedFetchRetailerMapping,

    addedRetailerMapping,
    failedAddRetailerMapping,

    fetchedCompanyVisibilitySheetData,
    failedFetchCompanyVisibilitySheetData,
    updatedDocumentStatus,
    failedUpdateDocumentStatus,
    fetchedCamEngineView,
    failedFetchCamEngineView,
    fetchedBounceCharges,
    failedFetchBounceCharges,
    fetchedPrePaymentCharges,
    failedFetchPrePaymentCharges,
    fetchedBounceChargesMaster,
    failedFetchBounceChargesMaster,
    fetchedPrePaymentChargesMaster,
    failedFetchPrePaymentChargesMaster,
    fetchedPortfolioView,
    failedFetchPortfolioView,
    fetchedCamEngineViewComments,
    failedFetchCamEngineViewComments,
    fetchedCamEngineStatusLogs,
    failedFetchCamEngineStatusLogs

    
} from "../actions";
import { tenorMaster } from "./../constants/scheme-data";
import history from "./../../../router/history";
import { CaseService, CompanyService } from "../../../services";

function* fetchCompanyLosProfilelistHandler({ payload: {
    filters
} }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.getCompanyLosProfiles,
            filters
        );
        if (error) {
            yield put(failedFetchCompanyLosProfileList(filters, error));
            return;
        }
        yield put(fetchedCompanyLosProfileList(filters, data.results, data.count));
    } catch (error) {
        yield put(failedFetchCompanyLosProfileList(filters, error));
    }
}

function* fetchRetailerMappingHandler({payload: {companyId}}) {
    try {
        const {error, data} = yield call(
            CompanyLosService.fetchRetailerMapping,
            companyId
        );
        if(!error) {
            yield put(fetchedRetailerMapping(companyId, data.data));
        } else {
            yield put(failedFetchRetailerMapping(companyId, error));    
        }
    } catch(error) {
        yield put(failedFetchRetailerMapping(companyId, error));
    }
}

function* fetchCompanyVisibilitySheetHandler({payload: {companyId}}) {
    try {
        const {error, data} = yield call(
            CompanyLosService.fetchCompanyVisibiltySheetData,
            companyId
        );
        if(!error) {
            yield put(fetchedCompanyVisibilitySheetData(companyId, data));
        } else {
            yield put(failedFetchCompanyVisibilitySheetData(companyId, error));    
        }
    } catch(error) {
        yield put(failedFetchCompanyVisibilitySheetData(companyId, error));
    }
}

function* addRetailerMapping({payload: {companyId, retailerMapping}}) {
    try {
        message.loading("Updating Dealer's Account Mapping...", 0);
        const {error, data} = yield call(
            CompanyLosService.addRetailerMapping,
            companyId,
            retailerMapping
        );
        message.destroy();
        if(!error) {
            yield put(addedRetailerMapping(companyId, data));
            yield put(fetchRetailerMapping(companyId));
            message.success("Dealer's Account Mapping Updated");
        } else {
            yield put(failedAddRetailerMapping(companyId, retailerMapping, error && error.errors));
            yield put(fetchRetailerMapping(companyId));
            message.error("Failed to Update Dealer's Mapping");
        }
    } catch(error) {
        message.destroy();
        yield put(failedAddRetailerMapping(companyId, retailerMapping, error && error.errors));
        // yield put(fetchRetailerMapping(companyId));
        message.error("Failed to Update Dealer's Mapping");
    }
}

function* validateDocument({payload: {company_id,file}}) {
    try {
        message.loading("Updating Document",2);
        const {error}=yield call(
            CompanyLosService.validateDocument,
            company_id,
            file && file.id,
            file && {
                file_name: file.file_name,
                id: file.id,
                document: file.document? file.document.id :null,
                document_option : file.document_option,
                document_status: file.document_status,
                is_active: file.is_active,
                remarks: file.remarks,
                parse_data: file.parse_data,
                request_remarks: file.request_remarks
            }
        );

        if(!error) {
            yield put(validatedDocument(company_id,file));
            message.info("Updated Document",2);
            // yield put(fetchCompanyLosAttachments(company_id));
            return;
        }
        message.info("Failed Approve Document",2);
        yield put(failedValidateDocument(company_id,file));
    } catch(error) {

        message.info("Failed Approve Document",2);
        yield failedValidateDocument(company_id,file, error);
    }
}

function* invalidateDocument({payload: {company_id,file}}) {
    try {
        message.loading("Invalidating Document",2);
        const {error}=yield call(
            CompanyLosService.validateDocument,
            company_id,
            file && file.id,
            file && {
                file_name: file.file_name,
                id: file.id,
                document: file.document? file.document.id :null,
                document_status: file.document_status,
                is_active: file.is_active,
                remarks: file.remarks,
                parse_data: file.parse_data,
                request_remarks: file.request_remarks
            }
        );

        if(!error) {
            yield put(invalidatedDocument(company_id,file));
            message.info("Invalidated Document",2);
            // yield put(fetchCompanyLosAttachments(company_id));
            return;
        }
        message.info("Failed Invalidate Document",2);
        yield put(failedInvalidateDocument(company_id,file));
    } catch(error) {

        message.info("Failed Invalidate Document",2);
        yield failedValidateDocument(company_id,file, error);
    }
}

function* createCompanyProfile({ payload: { companyData } }) {
    try {

        const { data, error } = yield call(
            CompanyLosService.createCompanyProfile,
            companyData
        );
        if (error) {
            message.error("Failed to create Company");
            yield put(failedCreateCompanyLosProfile(error));
            return;
        }
        message.success("Company Created");
        yield put(createdCompanyLosProfile(data));
        yield put(fetchCompanyLosProfileList());
        history.replace(`/app/companies/${data.id}`);
    } catch (error) {
        message.error("Failed to create Company");
        yield put(failedCreateCompanyLosProfile(error));
    }
}

function* createCompanySpocUser({ payload: { companyId, spocUser } }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.createUpdateCompanyLosSpocUser,
            companyId,
            spocUser.map(_ => _.set("company", companyId))
        );
        if (error) {
            message.error("Failed to create Company");
            yield put(failedCreateCompanyLosProfile(error));
            return;
        }
        message.success("Company Spoc User Created");
        yield put(updatedCompanyLosSpocUser(companyId, data));
    } catch (error) {
        message.error("Failed to create Company Spoc User");
        yield put(failedUpdateCompanyLosSpocUser(error));
    }
}

function* createCompanyDisbursalAccount({ payload: { companyId, bankDetails } }) {
    try {
        const { data, error } = yield call(CompanyLosService.updateBankAccounts,
            companyId,
            bankDetails
        );
        if (!error) {
            yield put(fetchRetailerMapping(companyId));
            yield put(updatedCompanyDisbursalAccount(companyId, data));
            yield put(fetchRetailerMapping(companyId));
            message.success("Disbursal Account Updated");
        } else {
            yield put(failedUpdateCompanyDisbursalAccount(companyId, error));
            message.error("Failed to Update Disbursal Account");
        }
    } catch (error) {
        yield put(failedUpdateCompanyDisbursalAccount(companyId, error));
        message.error("Failed to Update Disbursal Account");
    }
}

function* fetchCompanyLosProfile({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getCompanyLosProfile, payload.companyId);
        if (!error) {
            yield put(fetchedCompanyLosProfile(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyLosProfile(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosProfile(payload.companyId, error));
    }
}

function* updateCompanyLosProfile({ payload }) {
    try {
        const { error } = yield call(
            CompanyLosService.updateCompanyLosProfile,
            payload.companyId,
            payload.companyProfile.json
        );
        let associates = payload.companyProfile && payload.companyProfile.associates;
        if(associates && associates.size) {
            associates = payload.companyProfile && 
                payload.companyProfile.associates && 
                payload.companyProfile.associates.toList().toArray();
        }
        if (!error) {
            let spocUserJson = payload.companyProfile.spoc_user_json;
            if(spocUserJson && spocUserJson.size) {
                spocUserJson = spocUserJson.toList().toArray();
            }
            if (spocUserJson && spocUserJson.length) {
                try {
                    const { spocUpdateError, data } = yield call(
                        CompanyLosService.createUpdateCompanyLosSpocUser,
                        payload.companyId,
                        spocUserJson
                    );
                    if (spocUpdateError) {
                        message.error("Key Contact Person couldn't be updated", 3);
                        yield put(failedUpdateCompanyLosProfile(payload.companyId, spocUpdateError));
                        return;
                    } else {
                        yield put(updatedCompanyLosSpocUser(payload.companyId, data));
                        associates = new List(data
                            .filter(_ => _.is_active).map(_ => new AssociateRecord(_))
                        ).toMap()
                            .mapEntries(([,v]) => [v.id, v]);
                        message.success("Key Contact Person Updated", 3);
                    }
                } catch (err) {
                    message.error("Key Contact Person couldn't be updated", 3);
                    yield put(failedUpdateCompanyLosProfile(payload.companyId, error));
                }
            }
            // const companyAccounts = payload.companyProfile.bank_accounts;
            let profile = payload.companyProfile;
            // if (companyAccounts && (companyAccounts.length || companyAccounts.size)) {
            //     try {
            //         const account = yield call(
            //             CompanyLosService.updateBankAccounts,
            //             payload.companyId,
            //             companyAccounts.map(_ => {
            //                 const row = _.set("company", payload.companyId);
            //                 return row.formValues;
            //             }).toList().toArray()
            //         );
            //         if (!account.data) {
            //             message.error("Company Disbursal Account Couldn't be Updated");
            //             return;
            //         }
            //         message.success("Company Disbursal Account Updated");
            //         profile = profile.set("bank_accounts", new List(account.data).toMap().mapEntries(([, v]) => [v.id, v]));
            //         yield put(fetchRetailerMapping(payload.companyId));
            //     } catch(err) {
            //         message.error("Company Disbursal Account Couldn't be Updated");
            //     }
            // }
            message.success("Company Profile Updated");
            profile = profile.set("associates", associates);
            yield put(updatedCompanyLosProfile(payload.companyId, profile));
        } else {
            message.error("Company couldn't be updated", 3);
            yield put(failedUpdateCompanyLosProfile(payload.companyId, error));
        }
    } catch (error) {
        message.error("Company couldn't be updated", 3);
        yield put(failedUpdateCompanyLosProfile(payload.companyId, error));
    }
}

function* fetchCompanyLosDetail({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getCompanyLosDetail, payload.companyId);
        if (!error) {
            yield put(fetchedCompanyLosDetail(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyLosDetail(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosDetail(payload.companyId, error));
    }
}

function* fetchDbRiskControlDetailSaga({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getDBRiskControlDetail, payload.companyId);
        if (!error) {
            yield put(fetchedDbRiskControlDetail(payload.companyId, data));
        } else {
            yield put(failedFetchDbRiskControlDetail(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchDbRiskControlDetail(payload.companyId, error));
    }
}

function* updateDbRiskControlDetail({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.postDBRiskControlDetail, payload.dbRiskControlDetail, payload?.requestType);
        if (!error) {
            message.success("Product Details Updated!");
            yield put(updatedDbRiskControlDetail(payload.companyId, data));
            yield put(fetchDbRiskControlDetail(payload.companyId));
        } else {
            yield put(failedUpdateDbRiskControlDetail(payload.companyId, error));
        }
    } catch (error) {
        // message.error(error ? Object.entries(error)?.map(([key,val])=>`${key}: ${val[0]}`) : "Something went wrong!");
        yield put(failedUpdateDbRiskControlDetail(payload.companyId, error));
    }
}

function* updateCompanyLosDetailHandler({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.updateCompanyLosDetail, payload.companyId, payload.companyDetail);

        if (!error) {
            yield put(updatedCompanyLosDetail(payload.companyId, data));
            message.success("Company Details Updated");
        } else {
            yield put(failedUpdateCompanyLosDetail(payload.companyId, error));
            message.error("Company Detail Update Failed");
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosDetail(payload.companyId, error));
        message.error(error && Object.values(error) && Object.values(error)[0]);
        message.error("Company Detail Update Failed");
    }
}

function* updateCompanyLosSchemes({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.updateCompanyLosSchemes, payload.companyId, payload.schemes);

        if (!error) {
            yield put(updatedCompanyLosSchemes(payload.companyId, data));
            message.success("Company Schemes Updated");
        } else {
            yield put(failedUpdateCompanyLosSchemes(payload.companyId, error));
            message.error("Company Scheme Update Failed");
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosSchemes(payload.companyId, error));
        message.error("Company Scheme Update Failed");
    }
}

function* fetchCompanyLosErpsHandler({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getLosErps, payload.companyId);
        if (!error) {
            yield put(fetchedCompanyLosErps(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyLosErps(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosErps(payload.companyId, error));
    }
}

function* fetchCompanyLosBankingFacilitiesHandler({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getLosBankingFacilities, payload.companyId);
        if (!error) {
            yield put(fetchedCompanyLosBankingFacilities(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyLosBankingFacilities(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosBankingFacilities(payload.companyId, error));
    }
}

function* fetchCompanyLosAnnualTurnoversHandler({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getLosAnnualTurnovers, payload.companyId);
        if (!error) {
            yield put(fetchedCompanyLosAnnualTurnovers(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyLosAnnualTurnovers(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosAnnualTurnovers(payload.companyId, error));
    }
}

function* fetchCompanyLosBrandsHandler({ payload }) {
    const { data, error } = yield call(CompanyLosService.getLosBrands, payload.companyId);
    if (!error) {
        yield put(fetchedCompanyLosBrands(payload.companyId, data));

    } else {
        yield put(failedFetchCompanyLosBrands(payload.companyId, error));
    }
}

function* deleteCompanyBrands({ payload }) {
    try {
        const { error } = yield call(CompanyLosService.deleteBrands, payload.brandId);
        if (!error) {
            message.success("Company Brand Deleted");
            yield put(fetchCompanyLosBrands(payload.companyId));
            yield put(deletedBrands(payload.companyId));
        } else {
            message.error("Failed to Delete Company Brand");
            yield put(failedeleteBrands(payload.companyId));
        }
    } catch (error) {
        message.error("Failed to Delete Company Brand");
        yield put(failedeleteBrands(payload.companyId));
    }
}

function* deleteCompanyTurnover({ payload }) {
    try {
        const { error } = yield call(CompanyLosService.deleteAnnualTurnover, payload.turnoverId);
        if (!error) {
            message.success("Company Turnover Deleted");
            yield put(fetchCompanyLosAnnualTurnovers(payload.companyId));
            // yield put(deletedBrands(payload.companyId));
        } else {
            message.error("Failed to Delete Company Turnover");
            // yield put(failedeleteBrands(payload.companyId));
        }
    } catch (error) {
        message.error("Failed to Delete Annual Turnover");
    }
}

function* deleteCompanyErpDetails({ payload }) {
    try {
        const { error } = yield call(CompanyLosService.deleteErpDetails, payload.erpId);
        if (!error) {
            message.success("Company ErpDetails Deleted");
            yield put(fetchCompanyLosErps(payload.companyId));
            // yield put(deletedBrands(payload.companyId));
        } else {
            message.error("Failed to Delete Company ErpDetails");
            // yield put(failedeleteBrands(payload.companyId));
        }
    } catch (error) {
        message.error("Failed to Delete Annual ErpDetails");
    }
}

function* deleteCompanyBankingFacility({ payload }) {
    try {
        const { error } = yield call(CompanyLosService.deleteBankingFacility, payload.facilityId);
        if (!error) {
            message.success("Company ErpDetails Deleted");
            yield put(fetchCompanyLosBankingFacilities(payload.companyId));
            // yield put(deletedBrands(payload.companyId));
        } else {
            message.error("Failed to Delete Company ErpDetails");
            // yield put(failedeleteBrands(payload.companyId));
        }
    } catch (error) {
        message.error("Failed to Delete Annual ErpDetails");
    }
}

function* fetchCompanyLosAttachmentHandler({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getCompanyDocuments, payload.companyId, payload.is_anchor);
        if (!error) {
            yield put(fetchedCompanyLosAttachments(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyLosAttachments(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosAttachments(payload.companyId, error));
    }
}

function* uploadCompanyLosAttachment({ payload }) {
    try {
        const { error, data } = yield call(CompanyLosService.uploadCompanyLosAttachment, payload.companyId, payload.companyAttachment);
        if (!error) {
            yield put(uploadedCompanyLosAttachment(payload.companyId, data));
        } else {
            yield put(failedUploadCompanyLosAttachment(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosAttachments(payload.companyId, error));
    }
}

function* updateCompanyLosAttachments({ payload }) {
    try {
        const { error } = yield call(CompanyLosService.updateCompanyLosAttachments, payload.companyId, payload.companyAttachments);
        if (!error) {
            yield put(updatedCompanyLosAttachments(payload.companyId, payload.companyAttachments));
        } else {
            yield put(failedUpdateCompanyLosAttachments(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosAttachments(payload.companyId, error));
    }
}

function* updateCompanyLosErps({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.updateCompanyErps, payload.companyId, payload.erps);
        if (!error) {
            yield put(updatedCompanyLosErps(payload.companyId, data));
            message.success("Company ERPs Updated");
        } else {
            yield put(failedUpdateCompanyLosErps(payload.companyId, error));
            message.error("Company ERP Details Update Failed");
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosErps(payload.companyId, error));
        message.error("Company ERP Details Update Failed");
    }
}
function* updateCompanyLosBankingFacilities({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.putCompanyLosBankingFacilities, payload.companyId, payload.bankingFacilities);
        if (!error) {
            yield put(updatedCompanyLosBankingFacilities(payload.companyId, data));
            message.success("Company Banking Facilities Updated");
        } else {
            yield put(failedUpdateCompanyLosBankingFacilities(payload.companyId, error));
            message.error("Company Banking Facilities Update Failed");
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosBankingFacilities(payload.companyId, error));
        message.error("Company Banking Facilities Update Failed");
    }
}
function* updateCompanyLosAnnualTurnovers({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.putCompanyLosAnnualTurnovers, payload.companyId, payload.annualTurnovers);
        if (!error) {
            yield put(updatedCompanyLosAnnualTurnovers(payload.companyId, data));
            message.success("Company Annual Turnover Updated");
        } else {
            yield put(failedUpdateCompanyLosAnnualTurnovers(payload.companyId, error));
            message.error("Company Annual Turnover Update Failed");
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosAnnualTurnovers(payload.companyId, error));
        message.error("Company Annual Turnover Update Failed");
    }
}
function* updateCompanyLosBrands({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.putCompanyLosBrands, payload.companyId, payload.brands);
        if (!error) {
            yield put(updatedCompanyLosBrands(payload.companyId, data));
            message.success("Company Brands Updated");
        } else {
            yield put(failedUpdateCompanyLosBrands(payload.companyId, error));
            message.error("Company Brands Update Failed");
        }
    } catch (error) {
        yield put(failedUpdateCompanyLosBrands(payload.companyId, error));
        message.error("Company Brands Update Failed");
    }
}

function* fetchCompanyLosSchemes({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.getSchemeDetails,
            payload.companyId,
            { include_false: true }
        );
        if (!error) {
            yield put(fetchedCompanyLosSchemes(payload.companyId, data));

        } else {
            yield put(failedFetchCompanyLosSchemes(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyLosSchemes(payload.companyId, error));
    }
}

function* fetchCompanySellerSchemes({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getCompanySellerSchemesList, payload.companyId);
        if (!error) {
            yield put(fetchedCompanySellerSchemes(payload.companyId, data.results));

        } else {
            yield put(failedFetchCompanySellerSchemes(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanySellerSchemes(payload.companyId, error));
    }
}



function* fetchFees({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getFee, payload.companyId);
        if (!error) {
            yield put(fetchedFee(payload.companyId, data));
        } else {
            yield put(failedFetchFee(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchFee(payload.companyId, error));
    }
}

function* fetchFeeMaster() {
    try {
        const { data, error } = yield call(CompanyLosService.getFeeMaster);
        if (!error) {
            yield put(fetchedFeeMaster(data));
        } else {
            yield put(failedFetchFeeMaster(error));
        }
    } catch (error) {
        yield put(failedFetchFeeMaster(error));
    }
}

function* fetchTenorMaster() {
    try {
        const { data, error } = yield call(CompanyLosService.getTenorList);
        if (!error) {
            yield put(fetchedTenorList(data.results.length ? data.results : tenorMaster));
        } else {
            yield put(failedFetchTenorList(error));
        }
    } catch (error) {
        yield put(failedFetchTenorList(error));
    }
}

function* fetchMarginList({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getMarginSubvention, payload.tenorId);
        if (!error) {
            yield put(fetchedMarginList(payload.tenorId, data.results));
        } else {
            yield put(failedFetchMarginList(error));
        }
    } catch (error) {
        yield put(failedFetchMarginList(error));
    }
}

function* fetchInterestList({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getInterestConf, payload.tenorId);
        if (!error) {
            yield put(fetchedInterestList(payload.tenorId, data));
        } else {
            yield put(failedFetchInterestList(error));
        }
    } catch (error) {
        yield put(failedFetchInterestList(error));
    }
}

function* getWithholdPercMasterList() {
    try {
        const { data, error } = yield call(CompanyLosService.getWithholdPercMasterList);
        if (!error) {
            yield put(fetchedWithholdPercMaster(data.results));
        } else {
            yield put(failedFetchWithholdPercMaster(error));
        }
    } catch (error) {
        yield put(failedFetchWithholdPercMaster(error));
    }
}

function* fetchCashbackMaster() {
    try {
        const { data, error } = yield call(CompanyLosService.getCashback);
        if (!error) {
            yield put(fetchedCashbackList(data.results));
        } else {
            yield put(failedFetchCashbackList(error));
        }
    } catch (error) {
        yield put(failedFetchCashbackList(error));
    }
}


function* fetchAddFee({ payload }) {
    try {
        if (payload.fee.id) {
            const { data, error } = yield call(CompanyLosService.editFee, payload.companyId, payload.fee, payload.fee.id);
            if (!error) {
                message.success("Fee Program Edited");
                yield put(fetchedAddFee(payload.companyId, payload.fee, data));
                yield put(fetchFee(payload.companyId));
            } else {
                yield put(failedFetchAddFee(payload.companyId, payload.fee, error));
            }
        } else {
            const { data, error } = yield call(CompanyLosService.addFee, payload.companyId, payload.fee);
            if (!error) {
                message.success("Fee Program Created");
                yield put(fetchedAddFee(payload.companyId, payload.fee, data));
                yield put(fetchFee(payload.companyId));
            } else {
                yield put(failedFetchAddFee(payload.companyId, payload.fee, error));
            }
        }
    } catch (error) {
        error.non_field_errors && message.error(error.non_field_errors[0]);
        yield put(failedFetchAddFee(payload.companyId, payload.fee, error));
    }
}

function* createSellerScheme({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.createSellerScheme,
            payload.companyId,
            payload.data
        );
        if (!error) {
            message.success("Scheme Created");
            yield put(createdSellerScheme(payload.companyId, data));
        } else {
            message.error("Failed to create Scheme");
            yield put(failedCreateSellerScheme(payload.companyId, error));
        }
    } catch (error) {
        message.error("Failed to create Scheme");
        yield put(failedCreateSellerScheme(payload.companyId, error));
    }
}

function* createSellerSchemeMapping({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.createSellerSchemeMapping,
            payload.companyId,
            payload.data
        );
        if (!error) {
            message.success("Scheme Mapping Created");
            yield put(createdSellerSchemeMapping(payload.companyId, data));
        } else {
            message.error("Failed to create Scheme Mapping");
            yield put(failedCreateSellerSchemeMapping(payload.companyId, error));
        }
    } catch (error) {
        message.error("Failed to create Scheme Mapping");
        yield put(failedCreateSellerSchemeMapping(payload.id, error));
    }
}

function* fetchCompanySchemeMapping({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getCompanySellerSchemeMappingList, payload.companyId);
        if (!error) {
            yield put(fetchedCompanySellerSchemesMappings(payload.companyId, data.results));
        } else {
            yield put(failedFetchCompanySellerSchemesMappings(payload.companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanySellerSchemesMappings(payload.companyId, error));
    }
}

function* updateSellerScheme({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.updateSellerScheme, payload.companyId, payload.schemeId, payload.data);
        if (!error) {
            yield put(updatedSellerScheme(payload.companyId, payload.schemeId, data));
            message.success("Scheme Updated");
        } else {
            yield put(failedUpdateSellerScheme(payload.companyId, payload.schemeId, error));
            message.error("Failed to update Scheme");
        }
    } catch (error) {
        yield put(failedUpdateSellerScheme(payload.companyId, payload.schemeId, error));
        message.error("Failed to update Scheme");
    }
}

function* updateSellerSchemeMapping({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.updateSellerSchemeMapping, payload.companyId, payload.schemeId, payload.data);
        if (!error) {
            yield put(updatedSellerSchemeMapping(payload.companyId, payload.schemeId, data));
            message.success("Scheme Updated");
        } else {
            yield put(failedUpdateSellerSchemeMapping(payload.companyId, payload.schemeId, error));
            message.error("Failed to update Scheme");
        }
    } catch (error) {
        yield put(failedUpdateSellerSchemeMapping(payload.companyId, payload.schemeId, error));
        message.error("Failed to update Scheme");
    }
}

function* fetchCompanySyncRequests({ payload: { status, pageNo, search, pageSize } }) {
    try {
        const { data, error } = yield call(CompanyLosService.getSyncRequest, status, pageNo, search, true, pageSize);
        if (!error) {
            yield put(fetchedCompanySyncRequest(status, pageNo, search, data, pageSize));
        } else {
            yield put(failedFetchCompanySyncRequest(status, pageNo, search, error, pageSize));
            message.error("Failed to fetch sync requests");
        }
    } catch (error) {
        yield put(failedFetchCompanySyncRequest(status, pageNo, search, error, pageSize));
        message.error("Failed to fetch sync requests");
    }
}

function* fetchCompanySyncRequestCounts() {
    try {
        const { data, error } = yield call(CompanyLosService.getSyncRequestCount);
        if (!error) {
            yield put(fetchedCompanySyncRequestCount(data));
        } else {
            yield put(failedFetchCompanySyncRequestCount(error));
            message.error("Failed to fetch sync requests");
        }
    } catch (error) {
        yield put(failedFetchCompanySyncRequestCount(error));
        message.error("Failed to fetch sync requests");
    }
}


function* fetchCompanySyncRequestProcessReject({payload: {requestId, is_base_file_required, body, formData, automatedFile}}) {
    try {
        if((is_base_file_required && body.base_file) || automatedFile){
            const fileUploadResponse = yield call(CompanyLosService.uploadBaseFile,requestId, formData);
            if(!fileUploadResponse.error){
                const { data, error } = yield call(CompanyLosService.processRejectRequest,requestId, body);
                if (!error) {
                    yield put(fetchCompanySyncRequest(2,1,""));
                    yield put(fetchCompanySyncRequestCount());
                    yield put(fetchedCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, data));
                } else {
                    yield put(failedFetchCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, error));
                    message.error("Failed to fetch sync requests");
                }
            } else {
                yield put(failedFetchCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData,fileUploadResponse. error));
                message.error("Failed to fetch sync requests");
            }
        } else {
            const { data, error } = yield call(CompanyLosService.processRejectRequest,requestId, body);
            if (!error) {
                yield put(fetchCompanySyncRequest(2,1,""));
                yield put(fetchCompanySyncRequestCount());
                yield put(fetchedCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData,data));
            } else {
                yield put(failedFetchCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, error));
                message.error("Failed to fetch sync requests");
            }
        }
    } catch (error) {
        yield put(failedFetchCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, error));
        message.error("Failed to fetch sync requests");
    }
}


function* fetchDataSyncRequest({ payload: { companyId, body, type } }) {
    try {
        if (type === "CREATE_ASSOCIATE") {
            const applicant = yield call(CompanyLosService.createUpdateCompanyLosSpocUser, companyId, [{
                first_name: body.first_name,
                last_name: body.last_name,
                phone: body.phone,
                designation: body.designation,
                company: companyId,
                id: null
            }]);
            body.contact_person = applicant.data[0].id;
            const { data, error } = yield call(CompanyLosService.generateDataSyncRequest, companyId, body);
            if (error || applicant.error) {
                yield put(failedFetchDataSyncRequest(companyId, body, type, data));
            } else {
                yield put(fetchedDataSyncRequest(companyId, body, type, data));
                message.success("Request submitted successfully");
            }
        } else if (type === 1) {
            const { data, error} = yield call(CompanyLosService.generateDataSyncRequest, companyId, body);
            if (error) {
                yield put(failedFetchDataSyncRequest(companyId, body, type, data));
            } else {
                yield put(fetchedDataSyncRequest(companyId, body, type, data));
                message.success("Request submitted successfully");
            }
        } else {
            const { data, error } = yield call(CompanyLosService.generateDataSyncRequest, companyId, body);
            let formData = new FormData();
            body.files.map(_ => formData.append("files", _));
            formData.append("company_erp_data_request_id", data.id);
            formData.append("mapping", body.mapping);
            const bulkUpload = yield call(CompanyLosService.ledgersUpload, companyId, formData);
            if (error || bulkUpload.error) {
                yield put(failedFetchDataSyncRequest(companyId, body, type, data));
            } else {
                yield put(fetchedDataSyncRequest(companyId, body, type, data));
                message.success("Request submitted successfully");
            }
        }
    } catch (error) {
        yield put(failedFetchDataSyncRequest(companyId, body, type, error));
    }
}

function* createCompanyAgreement({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.createCompanyAgreement,
            payload.companyId,
            payload.agreement
        );
        if(!error) {
            yield put(createdCompanyAgreement(payload.companyId, data));
            message.success("Agreement Created Successfully");
        } else {
            yield put(failedCreateCompanyAgreement(payload.companyId, error));
            message.error("Failed to create company Agreement");
        }
    } catch(error) {
        yield put(failedCreateCompanyAgreement(payload.companyId, error));
        message.error("Failed to create company Agreement");
    }
}

function* updateCompanyAgreement({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.createCompanyAgreement,
            payload.companyId,
            payload.agreement
        );
        if(!error) {
            yield put(updatedCompanyAgreement(payload.companyId, data));
            message.success("Agreement Updated Successfully");
        } else {
            yield put(failedUpdateCompanyAgreement(payload.companyId, error));
            message.error("Failed to update company Agreement");
        }
    } catch(error) {
        yield put(failedUpdateCompanyAgreement(payload.companyId, error));
        message.error("Failed to update company Agreement");
    }
}

function* fetchCompanyAgreement({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.getCompanyAgreement,
            payload.companyId
        );
        if(!error) {
            yield put(fetchedCompanyAgreement(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyAgreement(payload.companyId, error));
            message.error("Failed to fetch company Agreement");
        }
    } catch(error) {
        yield put(failedFetchCompanyAgreement(payload.companyId, error));
        message.error("Failed to fetch company Agreement");
    }
}

function* fetchCompanyAgreementDetail({ payload }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.getAgreementDetail,
            payload.companyId
        );
        if(!error) {
            yield put(fetchedCompanyAgreementDetail(payload.companyId, data));
        } else {
            yield put(failedFetchCompanyAgreementDetail(payload.companyId, error));
        }
    } catch(error) {
        yield put(failedFetchCompanyAgreementDetail(payload.companyId, error));
    }
}

function* generatePdf({ payload }) {
    try {
        const { error } = yield call(
            CompanyLosService.uploadPdf,
            payload.companyId,
            payload.data
        );

        if(!error) {
            message.success("File Generated and attached as Draft Agreement");
        } else {
            message.error("Failed to Upload Pdf");
        }
    } catch(error) {
        message.error("Failed to Upload Pdf");
    }
}

function* updateCompanyAddress({ payload: { companyId, type, address } }) {
    const { data, error } = yield call(
        CompanyLosService.updateAddresses,
        companyId,
        [address.formValues]
    );
    if (!error) {
        yield put(updatedCompanyAddress(companyId, type, data[0]));
        message.success("Company Address Updated");
    } else {
        yield put(failedUpdateCompanyAddress(companyId, type, error));
        message.error("Failed to Update Company Address");
    }
}

function* fetchSellerLedgerMasterHandler({ payload: {companyId, filters}}) {
    message.loading("Fetching Ledger Masters...", 0);
    try {
        const { data, error } = yield call(
            CompanyLosService.getLedgerMasterTable,
            companyId,
            filters
        );
        message.destroy();
        if(!error) {
            yield put(fetchedSellerLedgerMaster(companyId, data));
        } else {
            yield put(failedFetchSellerLedgerMaster(companyId, error));
        }
    } catch(error) {
        message.destroy();
        yield put(failedFetchSellerLedgerMaster(companyId, error));
    }
}

function* updateSellerLedgerMaster({ payload: {companyId, ledgerEntries}}) {
    message.loading("Updating Ledger Masters...", 0);
    try {
        const { data, error } = yield call(
            CompanyLosService.updateLedgerMasterTable,
            companyId,
            ledgerEntries
        );
        message.destroy();
        if(!error) {
            message.success("Ledger Masters got updated", 2);
            yield put(updatedSellerLedgerMaster(companyId, data));
            yield put(fetchSellerLedgerMaster(companyId));
        } else {
            message.error("Failed to update Ledger Masters");
            yield put(failedUpdateSellerLedgerMaster(companyId, error));

        }
    } catch(error) {
        message.destroy();
        message.error("Failed to update Ledger Masters");
        yield put(failedUpdateSellerLedgerMaster(companyId, error));
    }
}

function* updateDocumentStatus({payload : {companyId , file}}) {
    try {
        message.loading("Updating Document",2);
        const {data , error}= yield call(
            CompanyLosService.updateDocumentStatus,
            companyId,
            file 
        );
        console.log("error" , error);
        yield put(updatedDocumentStatus(data));
        if(file.verification_status === "Rejected"){
            message.error("Document Rejected Successfully",2);
        }else{
            message.success("Document Successfully Approved",2);
        }
    } catch(error) {
        message.info("Failed Approve Document",2);
        yield put(failedUpdateDocumentStatus(file, error));
    }
}

function* fetchCamEngineView({payload : {caseId}}) {
    try {
        const {data , error}= yield call(
            CompanyService.getCamEngineAutomation,
            caseId
        );
        yield put(fetchedCamEngineView(data, caseId));
    } catch(error) {
        message.error("Cam Engine Data Not Found",2);
        yield put(failedFetchCamEngineView(error, caseId));
    }
}

function* fetchCamEngineViewComments({payload : {caseId}}) {
    try {
        const {data , error}= yield call(
            CaseService.getCamViewComments,
            caseId
        );
        yield put(fetchedCamEngineViewComments(data, caseId));
    } catch(error) {
        message.error("Cam Engine Data Not Found",2);
        yield put(failedFetchCamEngineViewComments(error, caseId));
    }
}

function* fetchCamEngineStatusLogs({payload : {caseId}}) {
    try {
        const {data , error}= yield call(
            CaseService.getCamsBreachedCaseStatus,
            caseId
        );
        yield put(fetchedCamEngineStatusLogs(data, caseId));
    } catch(error) {
        message.error("Cam Engine Status Logs Data Not Found",2);
        yield put(failedFetchCamEngineStatusLogs(error, caseId));
    }
}


function* fetchPortfolioView({ payload: { caseId } }) {
    try {
        const { data, error } = yield call(
            CompanyLosService.portfolioData,
            caseId
        );
        yield put(fetchedPortfolioView(data, caseId));
    } catch (error) {
        message.error("Portfolio Data Not Found", 2);
        yield put(failedFetchPortfolioView(error, caseId));
    }
}

function* fetchBounceCharges({payload}) {
    try {
        const { data, error } = yield call(CompanyLosService.getBounceChargesData, payload.companyId);
        if (!error) {
            yield put(fetchedBounceCharges(data));
        } else {
            yield put(failedFetchBounceCharges(error));
        }
    } catch (error) {
        yield put(failedFetchBounceCharges(error));
    }
}

function* fetchPrePaymentCharges({payload}) {
    try {
        const { data, error } = yield call(CompanyLosService.getPrePaymentChargesData, payload.companyId);
        if (!error) {
            yield put(fetchedPrePaymentCharges(data));
        } else {
            yield put(failedFetchPrePaymentCharges(error));
        }
    } catch (error) {
        yield put(failedFetchPrePaymentCharges(error));
    }
}


function* fetchBounceChargesMaster() {
    try {
        const { data, error } = yield call(CompanyLosService.getBounceChargesMaster);
        if (!error) {
            yield put(fetchedBounceChargesMaster(data));
        } else {
            yield put(failedFetchBounceChargesMaster(error));
        }
    } catch (error) {
        yield put(failedFetchBounceChargesMaster(error));
    }
}

function* fetchPrePaymentChargesMaster() {
    try {
        const { data, error } = yield call(CompanyLosService.getPrePaymentChargeMaster);
        if (!error) {
            yield put(fetchedPrePaymentChargesMaster(data));
        } else {
            yield put(failedFetchPrePaymentChargesMaster(error));
        }
    } catch (error) {
        yield put(failedFetchPrePaymentChargesMaster(error));
    }
}


export default fork(function* () {
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_SELLER_LEDGER_MASTER, fetchSellerLedgerMasterHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_SELLER_LEDGER_MASTER, updateSellerLedgerMaster);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_PROFILE_LIST, fetchCompanyLosProfilelistHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.CREATE_COMPANY_LOS_PROFILE, createCompanyProfile);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_PROFILE, fetchCompanyLosProfile);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_DETAIL, fetchCompanyLosDetail);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_DB_RISK_CONTROL_DETAIL, fetchDbRiskControlDetailSaga);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_DB_RISK_CONTROL_DETAIL, updateDbRiskControlDetail);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ERPS, fetchCompanyLosErpsHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_BANKING_FACILITIES, fetchCompanyLosBankingFacilitiesHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ANNUAL_TURNOVERS, fetchCompanyLosAnnualTurnoversHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_BRANDS, fetchCompanyLosBrandsHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ATTACHMENTS, fetchCompanyLosAttachmentHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_PROFILE, updateCompanyLosProfile);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_DETAIL, updateCompanyLosDetailHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ERPS, updateCompanyLosErps);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_BANKING_FACILITIES, updateCompanyLosBankingFacilities);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS, updateCompanyLosAnnualTurnovers);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_BRANDS, updateCompanyLosBrands);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ATTACHMENTS, updateCompanyLosAttachments);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_SPOC_USER, createCompanySpocUser);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_SCHEMES, updateCompanyLosSchemes);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_SCHEMES, fetchCompanyLosSchemes);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_DISBURSAL_ACCOUNT, createCompanyDisbursalAccount);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_FEE, fetchFees);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_FEE_MASTER, fetchFeeMaster);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_ADD_FEE, fetchAddFee);
    yield takeLatest(COMPANY_LOS_ACTIONS.DELETE_ERP_DETAILS, deleteCompanyErpDetails);
    yield takeLatest(COMPANY_LOS_ACTIONS.DELETE_ANNUAL_TURNOVER, deleteCompanyTurnover);
    yield takeLatest(COMPANY_LOS_ACTIONS.DELETE_BRANDS, deleteCompanyBrands);
    yield takeLatest(COMPANY_LOS_ACTIONS.DELETE_BANKING_FACILITY, deleteCompanyBankingFacility);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_TENOR_LIST, fetchTenorMaster);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_MARGIN_LIST, fetchMarginList);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_INTEREST_LIST, fetchInterestList);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_CASHBACK_LIST, fetchCashbackMaster);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_SELLER_SCHEME, fetchCompanySellerSchemes);
    yield takeLatest(COMPANY_LOS_ACTIONS.CREATE_COMPANY_SELLER_SCHEME, createSellerScheme);
    yield takeLatest(COMPANY_LOS_ACTIONS.CREATE_COMPANY_SELLER_SCHEME_MAPPING, createSellerSchemeMapping);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_SELLER_SCHEME_MAPPING, fetchCompanySchemeMapping);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_SELLER_SCHEME, updateSellerScheme);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_SELLER_SCHEME_MAPPING, updateSellerSchemeMapping);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_WITHHOLD_PERC_MASTER, getWithholdPercMasterList);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST, fetchCompanySyncRequests);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST_COUNT, fetchCompanySyncRequestCounts);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT, fetchCompanySyncRequestProcessReject);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_DATA_SYNC_REQUEST, fetchDataSyncRequest);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_AGREEMENT, updateCompanyAgreement);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_AGREEMENT, fetchCompanyAgreement);
    yield takeLatest(COMPANY_LOS_ACTIONS.CREATE_AGREEMENT, createCompanyAgreement);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_AGREEMENT_DETAIL, fetchCompanyAgreementDetail);
    yield takeLatest(COMPANY_LOS_ACTIONS.GENERATE_PDF, generatePdf);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_COMPANY_PROFILE_ADDRESS, updateCompanyAddress);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPLOAD_COMPANY_LOS_ATTACHMENT, uploadCompanyLosAttachment);
    yield takeLatest(COMPANY_LOS_ACTIONS.INVALIDATE_COMPANY_DOCUMENT, invalidateDocument);
    yield takeLatest(COMPANY_LOS_ACTIONS.VALIDATE_COMPANY_DOCUMENT, validateDocument);
    yield takeLatest(COMPANY_LOS_ACTIONS.ADD_RETAILER_MAPPING, addRetailerMapping);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_RETAILER_MAPPING, fetchRetailerMappingHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_COMPANY_VISIBILITY_SHEET_DATA, fetchCompanyVisibilitySheetHandler);
    yield takeLatest(COMPANY_LOS_ACTIONS.UPDATE_DOCUMENT_STATUS, updateDocumentStatus);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE, fetchCamEngineView);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE_COMMENTS, fetchCamEngineViewComments);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE_STATUS_LOGS, fetchCamEngineStatusLogs);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_BOUNCE_CHARGES, fetchBounceCharges);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_PRE_PAYMENT_CHARGES, fetchPrePaymentCharges);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_BOUNCE_CHARGES_MASTER, fetchBounceChargesMaster);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_PRE_PAYMENT_CHARGES_MASTER, fetchPrePaymentChargesMaster);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_PORTFOLIO_VIEW, fetchPortfolioView);

});
